tinymce.addI18n("nl", {
    "#": "#",
    "Accessibility": "Toegankelijkheid",
    "Accordion": "Accordeon",
    "Accordion body...": "Accordeon body...",
    "Accordion summary...": "Accordeon samenvatting...",
    "Action": "Actie",
    "Activity": "Activiteit",
    "Address": "Adres",
    "Advanced": "Geavanceerd",
    "Align": "Uitlijnen",
    "Align center": "Centreren",
    "Align left": "Links uitlijnen",
    "Align right": "Rechts uitlijnen",
    "Alignment": "Uitlijning",
    "Alignment {0}": "Uitlijning {0}",
    "All": "Alle",
    "Alternative description": "Alternatieve beschrijving",
    "Alternative source": "Alternatieve bron",
    "Alternative source URL": "Alternatief bron-URL",
    "Anchor": "Anker",
    "Anchor...": "Anker...",
    "Anchors": "Ankers",
    "Animals and Nature": "Dieren en natuur",
    "Arrows": "Pijlen",
    "B": "B",
    "Background color": "Achtergrondkleur",
    "Background color {0}": "Achtergrondkleur {0}",
    "Black": "Zwart",
    "Block": "Blok",
    "Block {0}": "Blok {0}",
    "Blockquote": "Quote",
    "Blocks": "Blokken",
    "Blue": "Blauw",
    "Blue component": "Blauw component",
    "Body": "Body",
    "Bold": "Vetgedrukt",
    "Border": "Rand",
    "Border color": "Randkleur",
    "Border style": "Randstijl",
    "Border width": "Randbreedte",
    "Bottom": "Onder",
    "Browse files": "Browse bestanden",
    "Browse for an image": "Afbeelding zoeken",
    "Browse links": "Browse links",
    "Bullet list": "Lijst met opsommingstekens",
    "Cancel": "Annuleren",
    "Caption": "Onderschrift",
    "Cell": "Cel",
    "Cell padding": "Celopvulling",
    "Cell properties": "Celeigenschappen",
    "Cell spacing": "Celafstand",
    "Cell styles": "Cel stijlen",
    "Cell type": "Celtype",
    "Center": "Centreren",
    "Characters": "Tekens",
    "Characters (no spaces)": "Tekens (geen spaties)",
    "Circle": "Cirkel",
    "Class": "Klasse",
    "Clear formatting": "Opmaak wissen",
    "Close": "Sluiten",
    "Code": "Broncode",
    "Code sample...": "Codevoorbeeld...",
    "Code view": "Code bekijken",
    "Color Picker": "Kleurenkiezer",
    "Color swatch": "Kleurenwaaier",
    "Cols": "Kolommen",
    "Column": "Kolom",
    "Column clipboard actions": "Kolom klembord acties",
    "Column group": "Kolomgroep",
    "Column header": "Kolom kop",
    "Constrain proportions": "Verhoudingen behouden",
    "Copy": "Kopi\xebren",
    "Copy column": "Kopieer kolom",
    "Copy row": "Rij kopi\xebren",
    "Could not find the specified string.": "Kan opgegeven reeks niet vinden",
    "Could not load emojis": "Kan de emoji's niet laden",
    "Count": "Telling",
    "Currency": "Valuta",
    "Current window": "Huidige venster",
    "Custom color": "Aangepaste kleur",
    "Custom...": "Aangepast...",
    "Cut": "Knippen",
    "Cut column": "Knip kolom",
    "Cut row": "Rij knippen",
    "Dark Blue": "Donkerblauw",
    "Dark Gray": "Donkergrijs",
    "Dark Green": "Donkergroen",
    "Dark Orange": "Donkeroranje",
    "Dark Purple": "Donkerpaars",
    "Dark Red": "Donkerrood",
    "Dark Turquoise": "Donkerturquoise",
    "Dark Yellow": "Donkergeel",
    "Dashed": "Onderbroken",
    "Date/time": "Datum/tijd",
    "Decrease indent": "Inspringing verkleinen",
    "Default": "Standaard",
    "Delete accordion": "Verwijder Accordeon",
    "Delete column": "Kolom verwijderen",
    "Delete row": "Rij verwijderen ",
    "Delete table": "Tabel verwijderen",
    "Dimensions": "Afmetingen",
    "Disc": "Schijf",
    "Div": "Div",
    "Document": "Dokument",
    "Dotted": "Gestippeld",
    "Double": "Dubbel",
    "Drop an image here": "Hier een afbeelding neerzetten",
    "Dropped file type is not supported": "Gesleepte bestandstype wordt niet ondersteund",
    "Edit": "Bewerken",
    "Embed": "Insluiten",
    "Emojis": "Emoji's",
    "Emojis...": "Emoji's...",
    "Error": "Fout",
    "Error: Form submit field collision.": "Fout: Veldconflict bij versturen formulier.",
    "Error: No form element found.": "Fout: Geen formulierelement gevonden.",
    "Extended Latin": "Latijn uitgebreid ",
    "Failed to initialize plugin: {0}": "Niet gelukt om plug-in te initialiseren: {0}",
    "Failed to load plugin url: {0}": "Niet gelukt om URL plug-in te laden: {0}",
    "Failed to load plugin: {0} from url {1}": "Niet gelukt om plug-in te laden: {0} vanaf URL {1}",
    "Failed to upload image: {0}": "Niet gelukt om afbeelding te uploaden: {0}",
    "File": "Bestand",
    "Find": "Zoeken",
    "Find (if searchreplace plugin activated)": "Zoeken (als plug-in voor zoeken/vervangen geactiveerd is)",
    "Find and Replace": "Zoek en vervang",
    "Find and replace...": "Zoeken en vervangen...",
    "Find in selection": "Zoek in selectie",
    "Find whole words only": "Alleen hele woorden zoeken",
    "Flags": "Vlaggen",
    "Focus to contextual toolbar": "Focus op contextuele werkbalk instellen ",
    "Focus to element path": "Focus op elementenpad instellen ",
    "Focus to menubar": "Focus op menubalk instellen ",
    "Focus to toolbar": "Focus op werkbalk instellen ",
    "Font": "Lettertype",
    "Font size {0}": "Grootte lettertype {0}",
    "Font sizes": "Tekengroottes",
    "Font {0}": "Lettertype {0}",
    "Fonts": "Lettertypes",
    "Food and Drink": "Eten en drinken",
    "Footer": "Voettekst",
    "Format": "Opmaak",
    "Format {0}": "Formaat {0}",
    "Formats": "Opmaken",
    "Fullscreen": "Volledig scherm",
    "G": "G",
    "General": "Algemeen",
    "Gray": "Grijs",
    "Green": "Groen",
    "Green component": "Groen component",
    "Groove": "Groef",
    "Handy Shortcuts": "Handige snelkoppelingen",
    "Header": "Koptekst ",
    "Header cell": "Koptekstcel",
    "Heading 1": "Kop 1",
    "Heading 2": "Kop 2",
    "Heading 3": "Kop 3",
    "Heading 4": "Kop 4",
    "Heading 5": "Kop 5",
    "Heading 6": "Kop 6",
    "Headings": "Koppen",
    "Height": "Hoogte",
    "Help": "Help",
    "Hex color code": "Hex kleurcode",
    "Hidden": "Verborgen",
    "Horizontal align": "Horizontaal uitlijnen",
    "Horizontal line": "Horizontale lijn",
    "Horizontal space": "Horizontale ruimte",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID moet beginnen met een letter en daarna enkel gevolgd door letters, getallen, streepjes, punten, komma's of underscores.",
    "Image is decorative": "Afbeelding is decoratief",
    "Image list": "Afbeeldingslijst",
    "Image title": "Afbeeldingstitel",
    "Image...": "Afbeelding...",
    "ImageProxy HTTP error: Could not find Image Proxy": "ImageProxy HTTP fout: Kan geen Image Proxy vinden",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "ImageProxy HTTP fout: Incorrecte Image proxy URL",
    "ImageProxy HTTP error: Rejected request": "ImageProxy HTTP fout: Aanvraag afgewezen",
    "ImageProxy HTTP error: Unknown ImageProxy error": "ImageProxy HTTP fout: Onbekende ImageProxy fout",
    "Increase indent": "Inspringing vergroten",
    "Inline": "Inline",
    "Insert": "Invoegen",
    "Insert Template": "Sjabloon invoegen",
    "Insert accordion": "Accordeon toevoegen",
    "Insert column after": "Kolom invoegen na",
    "Insert column before": "Kolom invoegen voor ",
    "Insert date/time": "Datum/tijd invoegen",
    "Insert image": "Afbeelding invoegen",
    "Insert link (if link plugin activated)": "Link invoegen (als plug-in voor link geactiveerd is)",
    "Insert row after": "Rij onder invoegen ",
    "Insert row before": "Rij boven invoegen",
    "Insert table": "Tabel invoegen",
    "Insert template...": "Sjabloon invoegen...",
    "Insert video": "Video invoegen",
    "Insert/Edit code sample": "Codevoorbeeld invoegen/bewerken",
    "Insert/edit image": "Afbeelding invoegen/bewerken",
    "Insert/edit link": "Link invoegen/bewerken",
    "Insert/edit media": "Media invoegen/bewerken",
    "Insert/edit video": "Video invoegen/bewerken",
    "Inset": "Inzet",
    "Invalid hex color code: {0}": "Onjuiste hex kleurcode: {0}",
    "Invalid input": "Ongeldige invoer",
    "Italic": "Cursief",
    "Justify": "Uitvullen",
    "Keyboard Navigation": "Toetsenbord navigatie",
    "Language": "Taal",
    "Learn more...": "Leer meer...",
    "Left": "Links",
    "Left to right": "Van links naar rechts",
    "Light Blue": "Lichtblauw",
    "Light Gray": "Lichtgrijs",
    "Light Green": "Lichtgroen",
    "Light Purple": "Lichtpaars",
    "Light Red": "Lichtrood",
    "Light Yellow": "Lichtgeel",
    "Line height": "Lijnhoogte",
    "Link list": "Lijst met links",
    "Link...": "Link...",
    "List Properties": "Lijsteigenschappen",
    "List properties...": "Lijsteigenschappen...",
    "Loading emojis...": "Emoji's laden...",
    "Loading...": "Laden...",
    "Lower Alpha": "Kleine letters",
    "Lower Greek": "Kleine Griekse letters",
    "Lower Roman": "Kleine Romeinse cijfers",
    "Match case": "Identieke hoofdletters/kleine letters",
    "Mathematical": "Wiskundig",
    "Media poster (Image URL)": "Mediaposter (afbeeldings-url)",
    "Media...": "Media...",
    "Medium Blue": "Middelblauw",
    "Medium Gray": "Middelgrijs",
    "Medium Purple": "Middelpaars",
    "Merge cells": "Cellen samenvoegen",
    "Middle": "Centreren",
    "Midnight Blue": "Middernachtblauw",
    "More...": "Meer...",
    "Name": "Naam",
    "Navy Blue": "Marineblauw",
    "New document": "Nieuw document",
    "New window": "Nieuw venster",
    "Next": "Volgende",
    "No": "Nee",
    "No alignment": "Geen uitlijning",
    "No color": "Geen kleur",
    "Nonbreaking space": "Vaste spatie",
    "None": "Geen",
    "Numbered list": "Genummerde lijst",
    "OR": "OF",
    "Objects": "Objecten",
    "Ok": "Ok",
    "Open help dialog": "Help-scherm openen",
    "Open link": "Open koppeling",
    "Open link in...": "Link openen in...",
    "Open popup menu for split buttons": "Open het pop-up menu voor gesplitste  knoppen",
    "Orange": "Oranje",
    "Outset": "Begin",
    "Page break": "Pagina-einde",
    "Paragraph": "Alinea",
    "Paste": "Plakken",
    "Paste as text": "Plakken als tekst",
    "Paste column after": "Plak kolom na",
    "Paste column before": "Plak kolom voor",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Plakken gebeurt nu zonder opmaak. De tekst zal dus zonder opmaak worden geplakt tenzij je deze optie uit zet.",
    "Paste or type a link": "Een link plakken of typen",
    "Paste row after": "Rij plakken onder",
    "Paste row before": "Rij plakken boven",
    "Paste your embed code below:": "Plak de invoegcode hieronder:",
    "People": "Personen",
    "Plugins": "Plug-ins",
    "Plugins installed ({0}):": "Plug-ins ge\xefnstalleerd ({0}):",
    "Powered by {0}": "Mogelijk gemaakt met {0}",
    "Pre": "Pre",
    "Preferences": "Voorkeuren",
    "Preformatted": "Vooraf opgemaakt",
    "Premium plugins:": "Premium plug-ins:",
    "Press the Up and Down arrow keys to resize the editor.": "Druk op pijl-omhoog en pijl-omlaag om het formaat van de editor te wijzigen.",
    "Press the arrow keys to resize the editor.": "Druk op de pijltoetsen om het formaat van de editor te wijzigen.",
    "Press {0} for help": "Druk op {0} voor hulp",
    "Preview": "Voorbeeld",
    "Previous": "Vorige",
    "Print": "Afdrukken",
    "Print...": "Afdrukken... ",
    "Purple": "Paars",
    "Quotations": "Citaten",
    "R": "R",
    "Range 0 to 255": "Bereik 0 tot 255",
    "Red": "Rood",
    "Red component": "Rood component",
    "Redo": "Opnieuw uitvoeren",
    "Remove": "Verwijderen",
    "Remove color": "Kleur verwijderen",
    "Remove link": "Link verwijderen",
    "Replace": "Vervangen",
    "Replace all": "Alle vervangen",
    "Replace with": "Vervangen door",
    "Resize": "Formaat wijzigen",
    "Restore last draft": "Laatste concept herstellen",
    "Reveal or hide additional toolbar items": "Extra werkbalkitems tonen of verbergen",
    "Rich Text Area": "Rijk Tekst Gebied",
    "Rich Text Area. Press ALT-0 for help.": " Gebied met opgemaakte tekst. Druk op ALT-0 voor hulp.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Gebied met opgemaakte tekst. Druk op ALT-F9 voor menu. Druk op ALT-F10 voor werkbalk. Druk op ALT-0 voor help.",
    "Ridge": "Ribbel",
    "Right": "Rechts",
    "Right to left": "Van rechts naar links",
    "Row": "Rij",
    "Row clipboard actions": "Rij klembord acties",
    "Row group": "Rijgroep",
    "Row header": "Rij kop",
    "Row properties": "Rijeigenschappen",
    "Row type": "Rijtype",
    "Rows": "Rijen",
    "Save": "Opslaan",
    "Save (if save plugin activated)": "Opslaan (als plug-in voor opslaan geactiveerd is)",
    "Scope": "Bereik",
    "Search": "Zoeken",
    "Select all": "Alles selecteren",
    "Select...": "Selecteer...",
    "Selection": "Selectie",
    "Shortcut": "Snelkoppeling",
    "Show blocks": "Blokken weergeven",
    "Show caption": "Bijschrift weergeven",
    "Show invisible characters": "Onzichtbare tekens weergeven",
    "Size": "Formaat",
    "Solid": "Massief",
    "Source": "Bron",
    "Source code": "Broncode",
    "Special Character": "Speciale tekens",
    "Special character...": "Speciaal teken...",
    "Split cell": "Cel splitsen",
    "Square": "Vierkant",
    "Start list at number": "Begin lijst met nummer",
    "Strikethrough": "Doorhalen",
    "Style": "Stijl",
    "Subscript": "Subscript",
    "Superscript": "Superscript",
    "Switch to or from fullscreen mode": "Overschakelen naar of vanuit de volledig scherm-modus",
    "Symbols": "Symbolen",
    "System Font": "Systeemlettertype",
    "Table": "Tabel",
    "Table caption": "Tabel bijschrift",
    "Table properties": "Tabeleigenschappen",
    "Table styles": "Tabel stijlen",
    "Template": "Sjabloon",
    "Templates": "Sjablonen",
    "Text": "Tekst",
    "Text color": "Tekstkleur",
    "Text color {0}": "Tekstkleur {0}",
    "Text to display": "Weer te geven tekst",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "De ingevoerde URL lijkt op een e-mailadres. Wil je er het vereiste voorvoegsel mailto: aan toevoegen?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "De ingevoerde URL verwijst naar een extern adres. Wil je er het vereiste voorvoegsel http:// aan toevoegen?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "De ingevoerde URL verwijst naar een extern adres. Wilt u er het vereiste voorvoegsel https:// aan toevoegen?",
    "Title": "Titel",
    "To open the popup, press Shift+Enter": "Druk op Shift+Enter om de pop-up te openen",
    "Toggle accordion": "Accordeon aan / uit zetten",
    "Tools": "Extra",
    "Top": "Boven",
    "Travel and Places": "Reizen en plaatsen",
    "Turquoise": "Turkoois",
    "Underline": "Onderstrepen",
    "Undo": "Ongedaan maken",
    "Upload": "Uploaden",
    "Uploading image": "Afbeelding uploaden",
    "Upper Alpha": "Hoofdletters",
    "Upper Roman": "Grote Romeinse cijfers",
    "Url": "Url",
    "User Defined": "Door gebruiker gedefinieerd ",
    "Valid": "Geldig",
    "Version": "Versie",
    "Vertical align": "Verticaal uitlijnen",
    "Vertical space": "Verticale ruimte",
    "View": "Weergeven",
    "Visual aids": "Visuele hulpmiddelen",
    "Warn": "Waarschuwen",
    "White": "Wit",
    "Width": "Breedte",
    "Word count": "Aantal woorden",
    "Words": "Woorden",
    "Words: {0}": "Woorden: {0}",
    "Yellow": "Geel",
    "Yes": "Ja",
    "You are using {0}": "Je gebruikt {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Je hebt niet alles opgeslagen, weet je zeker dat je de pagina wilt verlaten?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Jouw browser ondersteunt geen rechtstreekse toegang tot het klembord. Gebruik in plaats daarvan de sneltoetsen Ctrl+X/C/V.",
    "alignment": "uitlijning",
    "austral sign": "austral-teken",
    "cedi sign": "cedi-teken",
    "colon sign": "colon-teken",
    "cruzeiro sign": "cruzeiro-teken",
    "currency sign": "valutateken",
    "dollar sign": "dollarteken",
    "dong sign": "dong-teken",
    "drachma sign": "drachme-teken",
    "euro-currency sign": "euroteken",
    "example": "voorbeeld",
    "formatting": "opmaak",
    "french franc sign": "franse franc-teken",
    "german penny symbol": "duitse pfennig-teken",
    "guarani sign": "guarani-teken",
    "history": "geschiedenis",
    "hryvnia sign": "hryvnia-teken",
    "indentation": "inspringing",
    "indian rupee sign": "indiaase roepie-teken",
    "kip sign": "kip-teken",
    "lira sign": "lire-teken",
    "livre tournois sign": "livre tournois-teken",
    "manat sign": "manat-teken",
    "mill sign": "mill-teken",
    "naira sign": "naira-teken",
    "new sheqel sign": "nieuwe sheqel-teken",
    "nordic mark sign": "noorse mark-teken",
    "peseta sign": "peseta-teken",
    "peso sign": "peso-teken",
    "ruble sign": "roebel-teken",
    "rupee sign": "roepie-teken",
    "spesmilo sign": "spesmilo-teken",
    "styles": "stijlen",
    "tenge sign": "tenge-teken",
    "tugrik sign": "tugrik-teken",
    "turkish lira sign": "turkse lire-teken",
    "won sign": "won-teken",
    "yen character": "yen-teken",
    "yen/yuan character variant one": "yen/yuan variant 1-teken",
    "yuan character": "yuan-teken",
    "yuan character, in hong kong and taiwan": "yuan-teken (Hong Kong en Taiwan)",
    "{0} characters": "{0} karakters",
    "{0} columns, {1} rows": "{0} kolommen, {1} rijen",
    "{0} words": "{0} woorden"
});